<!-- ./resources/assets/js/components/Home.vue -->
<template>
    <div class="profile-notification"  @click="readAll">
    <!--<a href="#">
        <i class="icon-megafono"></i>
    </a>-->
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
        <i class="icon-bell"></i>
        <!-- <notifications-counter :start=this.counter></notifications-counter> -->
    </a>
        <!-- <ul class="dropdown-menu col notificationblock">
            <li class="header">
                Latest comments</li>
            <li>
            <li>
                <ul class="menu">
                    <notification v-for="notification in notifications"
                                  :key="notification.id"
                                  :notification="notification">
                    </notification>
                </ul>
            </li>
        </ul> -->
    </div>
</template>

<script>
    import notification from './NotificationItem';
    export default {
        created() {
            this.fetchNotifications();
            this.fetch2Read();
            this.listenForChanges();
        },
        components: {
            notification
        },

        methods: {
            fetchNotifications() {
                const t = this;
                axios.defaults.baseURL = process.env.MIX_APP_URL;

                axios.get('/notifications/')
                    .then(({data}) => {
                        t.notifications = data;
                    })
            },
            readAll() {
                const t = this;
                axios.get('/notifications/readAll')
                    .then(({data}) => {
                       this.counter = data;

                    })
            },
            fetch2Read() {
                const t = this;
                axios.get('/notifications/2read')
                    .then(({data}) => {
                        this.counter = data;

                    })
            },
            listenForChanges() {
                Echo.channel('comments')
                    .listen('NewComment', post => {
                        if (!('Notification' in window)) {
                            alert('Web Notification is not supported');
                            return;
                        }
                        this.fetchNotifications();
                        this.counter = this.counter +1;

                        Notification.requestPermission(permission => {
                            let notification = new Notification(post.author+" on "+post.widget_name, {
                                body: post.title, // content for the alert
                                icon: "https://www.dynamicmarketing.it/wp-content/uploads/2019/02/DMD_overture-400x111-1.png" // optional image url
                            });
                            // link to page on clicking the notification
                            notification.onclick = () => {
                                window.open(window.location.href);
                            };
                        });
                    })
            }
        },
        data: function () {
            return {
                state: 'default',
                data: {
                    body: ''
                },
                counter: 0,
                notifications: []
            }
        },
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/admin/notificationCenter.vue